const OldPagesRoot = () => import('@/views/OldPagesRoot.vue')
const UserProfile = () => import('../components/UserProfile.vue')
const OldUserProfile = () => import('../components/OldUserProfile.vue')
const Account = () => import('../components/Account.vue')
const SubscriptionManagement = () => import('../components/SubscriptionManagement.vue')
const LiveClassView = () => import('../views/LiveClassView.vue')
const LiveClassesView = () => import('../views/LiveClassesView.vue')
const RecordingsView = () => import('../views/RecordingsView.vue')
const RecordingPlayerView = () => import('../views/RecordingPlayerView.vue')
const ClassesView = () => import('../views/ClassesView.vue')
const ClassView = () => import('../views/ClassView.vue')
const InstructorProfileView = () => import('../views/InstructorProfileView.vue')

import type { RouteRecordRaw } from 'vue-router'
import type { RouteConfig } from './types'

const OldPages: RouteConfig = {
  Profile: {
    path: 'profile',
    name: 'profile',
    component: UserProfile,
    meta: {
      requiresAuth: true,
      isCustomer: true,
      isSignup: false,
      showFilters: false,
      showInNavbar: false,
    },
  },
  OldProfile: {
    path: 'old-profile',
    name: 'old-profile',
    component: OldUserProfile,
    meta: {
      requiresAuth: true,
      isCustomer: true,
      isSignup: false,
      showFilters: false,
      showInNavbar: false,
    },
  },
  Account: {
    path: 'account',
    name: 'account',
    component: Account,
    meta: {
      requiresAuth: true,
      isCustomer: true,
      isSignup: false,
      showFilters: false,
      showInNavbar: false,
    },
  },
  SubscriptionManagement: {
    path: 'subscription-management',
    name: 'subscription-management',
    component: SubscriptionManagement,
    meta: {
      requiresAuth: true,
      isCustomer: true,
      isSignup: false,
      showFilters: false,
      showInNavbar: false,
    },
  },
  LiveClass: {
    path: 'live_class/:classInstanceId',
    name: 'live-class',
    component: LiveClassView,
    meta: {
      requiresAuth: true,
      hideNavbar: true,
      isCustomer: true,
      isSignup: false,
      showFilters: false,
      showInNavbar: false,
    },
  },
  LiveClasses: {
    path: 'live-classes',
    name: 'live-classes',
    component: LiveClassesView,
    meta: {
      requiresAuth: true,
      isCustomer: true,
      isSignup: false,
      showFilters: false,
      showInNavbar: false,
    },
  },
  Recordings: {
    path: 'recordings',
    name: 'recordings',
    component: RecordingsView,
    meta: {
      requiresAuth: true,
      isCustomer: true,
      isSignup: false,
      showFilters: false,
      showInNavbar: false,
    },
  },
  RecordingPlayer: {
    path: 'recordings/:classInstanceId',
    name: 'recording-player',
    component: RecordingPlayerView,
    meta: {
      requiresAuth: true,
      isCustomer: true,
      isSignup: false,
      showFilters: false,
      showInNavbar: false,
    },
  },
  Classes: {
    path: 'classes',
    name: 'classes',
    component: ClassesView,
    meta: {
      requiresAuth: true,
      isCustomer: true,
      isSignup: false,
      showFilters: false,
      showInNavbar: false,
    },
  },
  Class: {
    path: 'classes/:id',
    name: 'class',
    component: ClassView,
    meta: {
      requiresAuth: true,
      isCustomer: true,
      isSignup: false,
      showFilters: false,
      showInNavbar: false,
    },
  },
  InstructorProfile: {
    path: 'instructors/:id',
    name: 'instructor-profile',
    component: InstructorProfileView,
    meta: {
      requiresAuth: true,
      isCustomer: true,
      isSignup: false,
      showFilters: false,
      showInNavbar: false,
    },
  },
}

export const OLD_ROUTES: RouteRecordRaw = {
  path: '/',
  name: 'old-pages-root',
  component: OldPagesRoot,
  children: Object.values(OldPages) as RouteRecordRaw[],
}
